import { render, staticRenderFns } from "./StandalonePaymentForm.vue?vue&type=template&id=1aa9ff74"
import script from "./StandalonePaymentForm.vue?vue&type=script&lang=js"
export * from "./StandalonePaymentForm.vue?vue&type=script&lang=js"
import style0 from "./StandalonePaymentForm.vue?vue&type=style&index=0&id=1aa9ff74&prod&lang=scss"
import style1 from "./StandalonePaymentForm.vue?vue&type=style&index=1&id=1aa9ff74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports